import { defineStore } from 'pinia';
export const menuListStore = defineStore('menuListStore', {
  state: () => {
    return {
      menuList: [
        {
          name: '聊天',
          path: '/chat',
          id: 'chat',
          iconImg: 'https://img-fe.tengzhihh.com/image/7cc9d66dc956d5-48x49.png',
          iconImgActived: 'https://img-fe.tengzhihh.com/image/8d57fff0995a43-48x48.png',
        },
        {
          name: '同事',
          path: '/teamChat',
          id: 'teamChat',
          iconImg: 'https://img-fe.tengzhihh.com/image/4b51d805355800-48x49.png',
          iconImgActived: 'https://img-fe.tengzhihh.com/image/6013f5a716002f-48x48.png',
        },
        {
          name: '會話',
          path: '/conversation',
          id: 'conversation',
          iconImg: 'https://img-fe.tengzhihh.com/image/9a05a9a981b52e-48x49.png',
          iconImgActived: 'https://img-fe.tengzhihh.com/image/f8f28e12ae2cb3-48x48.png',
        },
        {
          name: '客戶',
          path: '/contact',
          id: 'contact',
          iconImg: 'https://img-fe.tengzhihh.com/image/2aaf23a9f68564-48x49.png',
          iconImgActived: 'https://img-fe.tengzhihh.com/image/2329656ecdb880-48x49.png',
        },
        {
          name: '公海池',
          path: '/seaspool',
          id: 'seaspool',
          iconImg: 'https://img-fe.tengzhihh.com/image/3e2a2a868e8179-48x42.png',
          iconImgActived: 'https://img-fe.tengzhihh.com/image/b2d72b96aa01fe-48x42.png',
        },
        // {
        //   name: '机器人',
        //   path: '/robot',
        //   id: 'robot',
        //   iconImg: 'https://img-fe.tengzhihh.com/image/72c4573048af28-48x49.png',
        //   iconImgActived: 'https://img-fe.tengzhihh.com/image/2df3b576e50c37-48x49.png',
        // },
        {
          name: '工單',
          path: '/ticket',
          id: 'ticket',
          module_id: -1, // 默認顯示
          iconImg: 'https://img-fe.tengzhihh.com/image/72c4573048af28-48x49.png',
          iconImgActived: 'https://img-fe.tengzhihh.com/image/2df3b576e50c37-48x49.png',
        },
        {
          name: '工作台',
          path: '/workspace',
          id: 'workspace',
          module_id: -1, // 默认显示
          iconImg: 'https://img-fe.tengzhihh.com/image/ce784253d506a4-36x37.png',
          iconImgActived: 'https://img-fe.tengzhihh.com/image/89b15429baa190-48x49.png',
        },
        {
          name: '設置',
          path: '/setting',
          id: 'setting',
          iconImg: 'https://img-fe.tengzhihh.com/image/c2dcb35fc62797-48x49.png',
          iconImgActived: 'https://img-fe.tengzhihh.com/image/7e7c7742efc5f5-48x49.png',
        },
      ],
      currentPath: '',
      keepAlivePaths: [
        {
          label: '工作台',
          name: 'workSpace',
          path: '/workspace/index',
          icon: 'https://img-fe.tengzhihh.com/image/89b15429baa190-48x49.png',
        },
      ],
      keepAliveExclude: [],
    };
  },
  actions: {
    setCurrentPath(path: string): void {
      this.currentPath = path;
    },
    checkExclude(v: string) {
      let index = this.keepAliveExclude.findIndex((i) => i === v);
      index !== -1 && this.keepAliveExclude.splice(index, 1);
    },
    addKeepAlivePath(v: any) {
      if (this.keepAlivePaths.findIndex((i) => i.path == v.path) === -1) {
        this.keepAlivePaths.push(v);
        this.setKeepAlivePathStorage();
      }
    },
    delKeepAlivePath(v: any) {
      let index = this.keepAlivePaths.findIndex((i) => i.path === v.path);
      this.keepAlivePaths.splice(index, 1);
      let includeInx = this.keepAliveExclude.findIndex((i) => i === v.name);
      includeInx === -1 && v.name && this.keepAliveExclude.push(v.name);
      this.setKeepAlivePathStorage();
    },
    clearKeepAlivePath() {
      this.keepAlivePaths = [
        {
          label: '工作台',
          name: 'workSpace',
          path: '/workspace/index',
          icon: 'https://img-fe.tengzhihh.com/image/89b15429baa190-48x49.png',
        },
      ];
      this.clearKeepAlivePathStorage();
    },
    initKeepAlivePathWithStorage() {
      const tmp = window.localStorage?.getItem('workspaceKeepAlivePathArr');
      if (tmp) {
        this.keepAlivePaths = JSON.parse(tmp);
      }
    },
    setKeepAlivePathStorage() {
      window.localStorage?.setItem('workspaceKeepAlivePathArr', JSON.stringify(this.keepAlivePaths));
    },
    clearKeepAlivePathStorage() {
      window.localStorage?.removeItem('workspaceKeepAlivePathArr');
    },
  },
});
